import { motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import styles from './IntroPage.module.css';
import { FloatingChit } from '../components/FloatingChit';
import { PuzzleChitGrid } from '../components/PuzzleChitGrid';
import LanguageSelector from './LanguageSelector';
import { LanguageContext } from './LanguageContext';
import { Play, Trophy } from 'lucide-react';
import gameIcon from '../assets/gamename.png';
import { INTRO, pageT } from '../utils/i18n';

export default function IntroPage() {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, INTRO);

  useEffect(() => {
    const html = document.documentElement;
    const prevHtml = html.style.overflow;
    const prevBody = document.body.style.overflow;
    html.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prevHtml;
      document.body.style.overflow = prevBody;
    };
  }, []);

  const handlePlay = () => {
    navigate('/register');
  };
  const handleInfo = () => {
    navigate('/levelmap');
  };
  return (
    <div className={styles.container}>
      {/* Language Selector */}
      <div className={styles.languageBox}>
        <LanguageSelector />
      </div>

      {/* Floating Background */}
      <div className={styles.floatingBg}>
        <FloatingChit
          color="yellow"
          delay={0}
          duration={8}
          x={10}
          y={80}
          rotate={360}
          icon="🎯"
        />
        <FloatingChit
          color="pink"
          delay={1}
          duration={7}
          x={20}
          y={90}
          rotate={-360}
          icon="🎨"
        />
        <FloatingChit
          color="blue"
          delay={2}
          duration={9}
          x={80}
          y={85}
          rotate={360}
          icon="🎪"
        />
        <FloatingChit
          color="green"
          delay={3}
          duration={10}
          x={60}
          y={95}
          rotate={360}
          icon="📩"
        />
        <FloatingChit
          color="red"
          delay={4}
          duration={9}
          x={30}
          y={35}
          rotate={360}
          icon="🔍"
        />
        <FloatingChit
          color="transprent"
          delay={5}
          duration={10}
          x={40}
          y={50}
          rotate={360}
          icon="✈️"
        />
        <FloatingChit
          color="white"
          delay={6}
          duration={7}
          x={20}
          y={35}
          rotate={360}
          icon="🎭"
        />
        <FloatingChit
          color="blue"
          delay={7}
          duration={9}
          x={80}
          y={85}
          rotate={360}
          icon="🎲"
        />
      </div>

      <div className={styles.main}>
        {/* Hero */}
        <motion.div
          className={styles.hero}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <motion.img
            src={gameIcon}
            alt="Chit Puzzle Game Icon"
            className={styles.gameIcon}
            animate={{ scale: [1, 1.05, 1] }}
            transition={{
              duration: 1.8,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />

          <div className={styles.puzzlePreview}>
            <PuzzleChitGrid />
          </div>

          <div className={styles.buttons}>
            <motion.button className={styles.playBtn} onClick={handlePlay}>
              <Play />
              {t.playNow}
            </motion.button>

            <motion.button className={styles.leaderBtn} onClick={handleInfo}>
              <Trophy /> {t.knowMore}
            </motion.button>
          </div>
        </motion.div>

        {/* Features */}
      </div>
      <div className={styles.floating_shapes}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}
